export function transferPositionNumber(positionUnit) {
    return ((positionUnit / 375) * 100).toFixed(2);
}
